import React from 'react';
import { connect } from 'react-redux';
import { HttpStateLine } from 'state-line';

import Dialog from 'xgimi-ui/Dialog';
import Form from 'xgimi-ui/Form';
import InfoText from 'xgimi-ui/Info/Text';
import Button from 'xgimi-ui/Button';

import StoreComponent, { mapStateToProps } from '../../../../../appComponents/Store';

import s from './.module.scss';
import Api from '../../../../../api';

interface Props {
  // 是否打开
  isOpen: boolean;
  // 数据
  data: Record<string, any>;
  // 回复的数据
  replyData: Record<string, any>;
  // 关闭
  onClose: () => void;
  // 保存成功
  onSuccess: () => void;

}

interface State {
}

/**
 * 回复
 */
class Component extends StoreComponent<Props, State> {
  // 回复内容
  private content: string | undefined = undefined;

  /**
   * 确认
   */
  private onConfirm = (): void => {
    // 没有编辑过并且没有传过来的参数
    if ((this.content === undefined && this.props.replyData?.content === undefined) || this.content === '') {
      this.storeState.common.toast.current?.show({ content: '请输入回复内容' });
      return;
    }
    this.reply();
  };

  /**
   * 回复
   */
  private reply = (): void => {
    // 修改已有的内容时带上回复编号
    const data: Record<string, any> = {};
    if (this.props.replyData.replyNo !== undefined) {
      data.replyNo = this.props.replyData.replyNo;
    }

    new HttpStateLine(new Api.crmFeedback.Reply({
      feedbackNo: this.props.data.feedbackNo,
      content: this.content,
      ...data,
    }), {
      onSuccess: () => {
        this.props.onSuccess();
         this.storeState.common.toast.current?.show({ content: '回复成功' });
      },
      onFail: (httpStateLine) => {
        this.storeState.common.toast.current?.show({ content: httpStateLine.result?.message });
      },
    }).run();
  };

  render(): React.ReactNode {
    return (
      <Dialog
        className={s.dialog}
        isOpen={this.props.isOpen}
        onClose={this.props.onClose}
        isResponsive={true}
        isAutoClose={true}
      >
        <div className={s.container}>
          <div className={s.actionButton}>
            <Button size="large" variant="text" color="primary" onClick={this.props.onClose}>取消</Button>
            <Button size="large" variant="text" color="primary" onClick={this.onConfirm}>确定</Button>
          </div>
          <Form className={s.form}>
            <InfoText
              className={s.reply}
              rowSize={8}
              placeholder="请输入回复内容"
              variant="outlined"
              isUpdate={true}
              data={this.props.replyData?.content}
              onUpdate={(data) => {
                this.content = data;
              }}
            />
          </Form>
        </div>
      </Dialog>
    );
  }
}
export default connect(mapStateToProps)(Component);
